import { filiereTrackHeroUrl } from '../constants/academiaPublicHero';
import { resolveBrandingLogoUrl } from './brandingUrl';
import type { PublicFiliere, PublicFiliereTrack } from './publicFilieres';

/** Image de couverture d’une famille de filières (domaine admin → 1ʳᵉ formation → slug statique). */
export function resolveTrackCoverImage(track: PublicFiliereTrack): string {
  const fromDomaine = resolveBrandingLogoUrl(track.urlImage);
  if (fromDomaine) return fromDomaine;

  const firstFiliereImage = track.filieres
    .map((f) => resolveBrandingLogoUrl(f.urlImage))
    .find(Boolean);
  if (firstFiliereImage) return firstFiliereImage;

  return filiereTrackHeroUrl(track.slug);
}

/**
 * Image d’une formation publique : image filière admin → image domaine admin → hero du slug.
 */
export function resolveFiliereCoverImage(
  filiere: Pick<PublicFiliere, 'urlImage'>,
  options?: { domaineUrlImage?: string | null; trackSlug?: string },
): string {
  const fromFiliere = resolveBrandingLogoUrl(filiere.urlImage);
  if (fromFiliere) return fromFiliere;

  const fromDomaine = resolveBrandingLogoUrl(options?.domaineUrlImage);
  if (fromDomaine) return fromDomaine;

  return filiereTrackHeroUrl(options?.trackSlug ?? '');
}
